// API service functions for communicating with the backend

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Send chat history to the chatbot API
export const getChatHistory = async () => {
  try {
    const response = await fetch('/api/chat/history');
    if (!response.ok) throw new Error('Failed to fetch history');
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
};
// Send a message to the chatbot API (updated to support images)
export const sendChatMessage = async (message, images = []) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message,
        images: images.map(img => ({
          data: img.data,
          type: img.type,
          name: img.name
        }))
      }),
    });

    return await response.json();
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};

// Send an email through the contact form API
export const sendContactEmail = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};